import { FunctionComponent, useState } from 'react'

import Bed from 'design-system/Iconography/SVG/Bed'

import { useElement } from 'services/hooks'

import BedRangeDropdown from '../Dropdowns/BedDropdown'
import { IBedProps, IFilterProps } from '../types'
import FilterButton from './Shared/FilterButton'

const renderIcon = () => <Bed />

const BedFilter: FunctionComponent<IFilterProps & IBedProps> = ({
  selectedBedRange,
  setSelectedBedRange,
  applyBedSelections,
  resetBedSelections,
  hide,
}) => {
  const [buttonRef, buttonElement] = useElement<HTMLDivElement>()
  const [visible, setVisible] = useState(false)

  const [applied, setApplied] = useState(false)
  const [label, setLabel] = useState('Beds')

  const [error, setError] = useState('')

  const clearSelection = () => {
    resetBedSelections()
    setLabel('Beds')
    setApplied(false)
    setVisible(false)
  }

  const handleApply = () => {
    if (!selectedBedRange.min && !selectedBedRange.max) return clearSelection()

    setApplied(true)
    applyBedSelections()

    const middleTerm = selectedBedRange.min && selectedBedRange.max ? '-' : ''
    const formattedMin = selectedBedRange.min ? selectedBedRange.min : 'Up to '
    const formattedMax = selectedBedRange.max ? selectedBedRange.max : '+'
    setLabel(`${formattedMin}${middleTerm}${formattedMax}`)

    setVisible(false)
  }

  return (
    <>
      <FilterButton
        ref={buttonRef}
        active={applied || visible}
        label={label}
        renderIcon={renderIcon}
        onClearSelection={clearSelection}
        clearable={applied}
        hide={hide}
      />
      <BedRangeDropdown
        buttonElement={buttonElement}
        visible={visible}
        setVisible={setVisible}
        error={error}
        setError={setError}
        onApply={handleApply}
        selectedBedRange={selectedBedRange}
        setSelectedBedRange={setSelectedBedRange}
        applyBedSelections={applyBedSelections}
        resetBedSelections={clearSelection}
      />
    </>
  )
}

export default BedFilter
